<template>
  <div class="page-content">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon stat-icon-users">
          <i class="ri-user-line"></i>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ stats.totalUsers }}</span>
          <span class="stat-label">总用户数</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon stat-icon-online">
          <i class="ri-user-follow-line"></i>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ stats.onlineUsers }}</span>
          <span class="stat-label">在线用户</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon stat-icon-groups">
          <i class="ri-group-line"></i>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ stats.totalGroups }}</span>
          <span class="stat-label">总群聊数</span>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon stat-icon-messages">
          <i class="ri-message-3-line"></i>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ stats.todayMessages }}</span>
          <span class="stat-label">今日消息</span>
        </div>
      </div>
    </div>

    <div class="charts-grid">
      <div class="chart-card">
        <div class="chart-header">
          <h3>用户增长趋势</h3>
          <div class="chart-period">
            <button
              v-for="p in ['7天', '30天', '90天']"
              :key="p"
              class="period-btn"
              :class="{ active: period === p }"
              @click="period = p"
            >
              {{ p }}
            </button>
          </div>
        </div>
        <div class="chart-body">
          <div class="chart-placeholder">
            <div class="chart-bars">
              <div v-for="(value, index) in userGrowthData" :key="index" class="chart-bar-wrapper">
                <div class="chart-bar" :style="{ height: (value / maxUserGrowth * 100) + '%' }"></div>
                <span class="chart-bar-label">{{ index + 1 }}日</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-card">
        <div class="chart-header">
          <h3>消息统计</h3>
        </div>
        <div class="chart-body">
          <div class="message-stats">
            <div class="message-stat-item">
              <span class="message-stat-label">
                <i class="ri-message-line"></i>
                今日私聊消息
              </span>
              <span class="message-stat-value">{{ stats.todayPrivateMessages }}</span>
            </div>
            <div class="message-stat-item">
              <span class="message-stat-label">
                <i class="ri-group-chat-line"></i>
                今日群聊消息
              </span>
              <span class="message-stat-value">{{ stats.todayGroupMessages }}</span>
            </div>
            <div class="message-stat-item">
              <span class="message-stat-label">
                <i class="ri-database-line"></i>
                总消息数
              </span>
              <span class="message-stat-value">{{ stats.totalMessages }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-card chart-wide">
        <div class="chart-header">
          <h3>活跃用户排行</h3>
        </div>
        <div class="chart-body">
          <div class="ranking-list">
            <div v-for="(user, index) in activeUsers" :key="user.id" class="ranking-item">
              <span class="ranking-rank" :class="{ top: index < 3 }">{{ index + 1 }}</span>
              <div class="ranking-user">
                <div class="ranking-avatar">
                  <i class="el-icon-user-solid"></i>
                </div>
                <span class="ranking-name">{{ user.name }}</span>
              </div>
              <span class="ranking-value">{{ user.messageCount }} 条消息</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsDashboard',
  data() {
    return {
      period: '7天',
      stats: {
        totalUsers: 0,
        onlineUsers: 0,
        totalGroups: 0,
        todayMessages: 0,
        todayPrivateMessages: 0,
        todayGroupMessages: 0,
        totalMessages: 0
      },
      userGrowthData: [12, 19, 15, 22, 18, 25, 20],
      activeUsers: [
        { id: 1, name: '用户001', messageCount: 1256 },
        { id: 2, name: '用户002', messageCount: 982 },
        { id: 3, name: '用户003', messageCount: 854 },
        { id: 4, name: '用户004', messageCount: 721 },
        { id: 5, name: '用户005', messageCount: 658 }
      ]
    }
  },
  computed: {
    maxUserGrowth() {
      return Math.max(...this.userGrowthData)
    }
  },
  mounted() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      try {
        const response = await this.$http({
          url: '/admin/system/statistics',
          method: 'get'
        })
        this.stats = { ...this.stats, ...response }
      } catch (error) {
        this.$message.error('加载统计数据失败')
      }
    }
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css');

.page-content {
  max-width: 100%;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.stat-icon i {
  font-size: 24px;
}

.stat-icon-users {
  background: #dbeafe;
  color: #2563eb;
}

.stat-icon-online {
  background: #dcfce7;
  color: #16a34a;
}

.stat-icon-groups {
  background: #fef3c7;
  color: #d97706;
}

.stat-icon-messages {
  background: #f3e8ff;
  color: #9333ea;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.chart-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.chart-wide {
  grid-column: span 2;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.chart-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.chart-period {
  display: flex;
  gap: 8px;
}

.period-btn {
  padding: 4px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.period-btn:hover {
  border-color: #07c160;
  color: #07c160;
}

.period-btn.active {
  background: #07c160;
  border-color: #07c160;
  color: #fff;
}

.chart-body {
  padding: 24px;
}

.chart-placeholder {
  height: 200px;
}

.chart-bars {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 180px;
  padding-top: 20px;
}

.chart-bar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
}

.chart-bar {
  width: 24px;
  background: linear-gradient(180deg, #07c160 0%, #06ae56 100%);
  border-radius: 4px 4px 0 0;
  min-height: 4px;
  transition: height 0.3s ease;
}

.chart-bar-label {
  font-size: 10px;
  color: #94a3b8;
}

.message-stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message-stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.message-stat-label {
  font-size: 14px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-stat-label i {
  font-size: 16px;
}

.message-stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}

.ranking-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ranking-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.ranking-rank {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ranking-rank.top {
  background: #07c160;
  color: #fff;
}

.ranking-user {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.ranking-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ecfdf5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #07c160;
  font-size: 16px;
}

.ranking-name {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.ranking-value {
  font-size: 14px;
  color: #64748b;
}
</style>